import InputConfig from '../../Components/InputConfig';
import DropDownSingle from '../../Components/DropDownSingle';
import SwitchInput from '../../Components/SwitchInput';
import { SCRIPT_TYPES } from './constants';
import { SPLIT_DOC_PARAMETERS } from '../../core/constants';
import DeleteIcon from '@mui/icons-material/Delete';
import useCommonStyles from '../../commonStyles';
import CodeEditor from '../../Components/CodeEditor';

//mui imports====
import { Grid, Typography } from '@mui/material';
import { Box } from '@mui/system';

//===============

const { TYPE, VALUE, DEFER, ASYNC } = SPLIT_DOC_PARAMETERS;
const { URL, SCRIPT, HTML } = SCRIPT_TYPES;

const ScriptCard = ({ scriptKey, updateScript, deleteScript, scriptData }) => {
	const commonStyleClasses = useCommonStyles();

	const updateScriptType = (scriptType) => {
		let newScriptData = { ...scriptData, [TYPE]: scriptType };
		//If script type is Html then defer and async should be false
		if (scriptType === HTML) {
			newScriptData[DEFER] = false;
			newScriptData[ASYNC] = false;
		}
		updateScript(scriptKey, newScriptData);
	};

	return (
		<Grid item xs={12}>
			<Box
				style={{
					border: '1px solid rgba(0, 0, 0, 0.38)',
					padding: '2rem',
					margin: '.4rem',
					borderRadius: '4px'
				}}
			>
				<Grid container rowGap={3}>
					<Grid item xs={6}>
						<Typography variant="h4" color="primary" fontWeight={800}>
							{scriptKey}
						</Typography>
					</Grid>
					<Grid
						item
						xs={6}
						style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '1rem' }}
					>
						<DeleteIcon
							color="primary"
							onClick={() => deleteScript(scriptKey)}
							className={commonStyleClasses.icon}
						/>
					</Grid>
					<Grid item xs={4}>
						<DropDownSingle
							isObjectEditor={false}
							label="Type"
							directValue={scriptData[TYPE]}
							updateDirectValue={(val) => {
								updateScriptType(val);
							}}
							isMandatory={true}
							formControlStyles={{ width: '100%', marginLeft: '0' }}
							labelStyles={{ width: '100%' }}
							list={[SCRIPT, URL, HTML]}
						/>
					</Grid>
					{scriptData[TYPE] !== HTML && (
						<Grid item xs={4}>
							<SwitchInput
								isObjectEditor={false}
								label="Defer"
								directValue={scriptData[DEFER]}
								updateDirectValue={(val) => {
									updateScript(scriptKey, { ...scriptData, [DEFER]: val });
								}}
								isMandatory={true}
								containerStyles={{ marginTop: '5rem', marginLeft: '10rem' }}
							/>
						</Grid>
					)}
					{scriptData[TYPE] !== HTML && (
						<Grid item xs={4}>
							<SwitchInput
								isObjectEditor={false}
								label="Async"
								directValue={scriptData[ASYNC]}
								updateDirectValue={(val) => {
									updateScript(scriptKey, { ...scriptData, [ASYNC]: val });
								}}
								isMandatory={true}
								containerStyles={{ marginTop: '5rem', marginLeft: '10rem' }}
							/>
						</Grid>
					)}
					<Grid item xs={12}>
						{scriptData[TYPE] === SCRIPT && (
							<CodeEditor
								height="40rem"
								language="javascript"
								value={scriptData[VALUE]}
								updateCode={(val, event) => {
									updateScript(scriptKey, { ...scriptData, [VALUE]: val });
								}}
							/>
						)}
						{scriptData[TYPE] === HTML && (
							<CodeEditor
								height="40rem"
								language="html"
								value={scriptData[VALUE]}
								updateCode={(val, event) => {
									updateScript(scriptKey, { ...scriptData, [VALUE]: val });
								}}
							/>
						)}
						{scriptData[TYPE] === URL && (
							<InputConfig
								isObjectEditor={false}
								inputType="string"
								label="Value"
								directValue={scriptData[VALUE]}
								updateDirectValue={(val) => {
									updateScript(scriptKey, { ...scriptData, [VALUE]: val });
								}}
								isMandatory={true}
								inputStyles={{
									width: '100%'
								}}
								labelStyles={{ width: '100%' }}
							/>
						)}
					</Grid>
				</Grid>
			</Box>
		</Grid>
	);
};

export default ScriptCard;
